import { resources } from "@constants/hardcoded-strings";
import { AXNUIContent } from "@iddataweb/idw-common-ui/types";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { ErrorCodeValidationError, ThemingErrorPageValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";
import { getThemingErrorCodes } from "@utils/content-util";
import { AxnuiErrorCodeTypes } from "@iddataweb/idw-common-ui/enums";

export const getThemingErrorPageValidationErrors = (
    isUsingThemedUI: boolean,
    axnuiContent: AXNUIContent
): ThemingErrorPageValidationErrors => {
    let count = 0;
    let errorTitleError = null;
    let errorDescriptionLabelError = null;
    let referenceIdLabel = null;

    const errorCodesValidationErrors: ErrorCodeValidationError = {};
    if (isUsingThemedUI) {
        if (!axnuiContent.error.errorTitle) {
            count += 1;
            errorTitleError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }

        if (axnuiContent.error.referenceIdLabel === "") {
            referenceIdLabel = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }

        if (axnuiContent.error.errorDescriptionLabel === "") {
            errorDescriptionLabelError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }

        const errorCodes = getThemingErrorCodes();

        errorCodes.forEach((errorCode: AxnuiErrorCodeTypes) => {
            if (axnuiContent.error[errorCode] === "") {
                errorCodesValidationErrors[errorCode] = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
                count++;
            } else {
                errorCodesValidationErrors[errorCode] = null;
            }
        });

    }

    return {
        errorTitleError,
        errorCodesErrors: errorCodesValidationErrors,
        referenceIdLabel,
        errorDescriptionLabelError,
        count: count,
        tabTitle: <TabTitleWithErrorCount
            tabName={resources.pages.verificationServiceDetails.tabs.theming.subTabs.errorPage.tabName}
            errorCount={count}
        />
    };
};